module.exports = __webpack_public_path__ + "img/meitiziyuan.220d9323.png";